module.exports = __webpack_public_path__ + "static/demo-screen-1-29a9c9b2fa9d9dbc85075499cb08fd5e.jpg";